import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UserProfileForm.html?raw';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';

import SimpleFileUpload from '../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import on from 'dojo/on';
import MusicianProfileForm from '../../MusicianProfileForm/MusicianProfileForm';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import UserInfoContainer from '../UserInfo/UserInfoContainer';
import "../UserInfo/UserInfoContainer";
class UserProfileForm extends compose(_StatefulSection) {
    templateString: any = template;

    //private iconNode: HTMLElement;

    private sectionMusicianProfile: MdsLax<InstanceType<typeof ExpandableSection>>;
    private musicianProfileform: MdsLax<InstanceType<typeof MusicianProfileForm>>;
    private containerMusicianProfile: HTMLDivElement;

    private sectionEmailAddresses: MdsLax<InstanceType<typeof ExpandableSection>>;
    private emailAddressTable: MdsLax<InstanceType<typeof StaticTable>>;
    private emailAddressStore: MdsLax<InstanceType<typeof EntityStore<UserEmail>>>;

    private userInfoContainer: MdsLax<InstanceType<typeof UserInfoContainer>>;

    private inputUserMail: MdsLax<InstanceType<typeof Edit>>;

    private _rowConfigEmail: StaticTable.RowConfig = {
        attributes: [
            "is_main_connection",
            "telecom_code",
            "ModificationUser"
        ],
        headings: [
            (this as any).translate("General_Label_IsMainConnection"),
            (this as any).translate("General_Label_Email"),
            (this as any).translate("General_ModificationUser")
        ],
        colNamesInternal: [
            "is_main_connection",
            "telecom_code",
            "ModificationUser"
        ],
        colspans: [
            1,
            3,
            1
        ]
    }

    private _tableLayoutEmail: StaticTable.Layout = {
        label: "emailTable",
        name: "emailTable",
        rows: [(this as any)._rowConfigEmail],
    }

    private _tableFormatterEmail(cell: StaticTable.StaticTableCell<UserEmail>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let value = cell.value;
        let node = cell.tableCellNode;

        switch (name) {
            case "is_main_connection":
                let checkbox = new CheckBox();
                checkbox.setValue(value, true);
                checkbox.on("change", lang.hitch(this, this._onChangeIsMainConnection, lang.clone(entity), checkbox));
                checkbox.placeAt(node);
                return true;
                break;
            case "telecom_code":
                let edit = new Edit();
                edit.setValue(value, true);
                edit.setInputType("email");
                edit.setValidationEnabled(true);
                edit.on("change", lang.hitch(this, this._onChangeTelecomCode, lang.clone(entity)));
                node.innerHTML = "";
                edit.placeAt(node);
                return true;
                break;
        }

        return false;
    }

    private _onChangeIsMainConnection(entity: UserEmail, checkbox: MdsLax<InstanceType<typeof CheckBox>>, e: boolean) {
        if (e) {
            entity.is_main_connection = e;
            this.emailAddressStore.changeEntry(entity, true);
            this.updateEmails(entity);
        } else {
            checkbox.setValue(!e, true);
        }
    }

    private _onClickDeleteEmail(rowGroup: StaticTable.StaticTableRowGroup<UserEmail>) {
        let entity = rowGroup.entity;
        if (entity.is_main_connection) {
            this.showToast(this.translate("General_Error_DeleteMainAddress"), "fas fa-exclamation-triangle")
        } else {
            this.emailAddressStore.deleteEntry(entity);
        }
    }

    private updateEmails(entity: UserEmail) {
        let currentEmails = this.emailAddressStore.getCurrentCompleteList();
        for (let email of currentEmails) {
            let copyEmail = lang.clone(email);
            if (copyEmail.ID !== entity.ID) {
                copyEmail.is_main_connection = false;
                this.emailAddressStore.changeEntry(copyEmail);
            }
        }
    }

    private _onChangeTelecomCode(entity: UserEmail, e: string) {
        entity.telecom_code = e;
        this.emailAddressStore.changeEntry(entity, true);
    }

    private _setupTableEmail(): void {
        this.emailAddressTable = new StaticTable();
        this.emailAddressStore = new EntityStore();
        this.emailAddressStore.on("change", lang.hitch(this, this._onChangeEmailStore));
        this.emailAddressTable.setLayout(this._tableLayoutEmail);
        this.emailAddressTable.setFormatter(lang.hitch(this, this._tableFormatterEmail));
        this.emailAddressTable.addCustomRowActionButton("deleteEmail", lang.hitch(this, this._onClickDeleteEmail), "fas fa-trash warningTXT");
        this.emailAddressTable.setupFromStore(this.emailAddressStore);
        this.emailAddressTable.setCyAttribute("UserProfileEmailAddressTable");
        this.emailAddressTable.placeAt(this.sectionEmailAddresses);
    }

    private _onChangeEmailStore(e): void {
        let emails = this.emailAddressStore.getCurrentCompleteList();
        this.sectionEmailAddresses.setMarking(emails.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.setAttributeValue("emailDiffData", this.emailAddressStore.getDiffData());
    }

    private _onClickNewEmail(e): void {
        let newEmail: UserEmail = {
            Classname: "",
            ID: "",
            is_main_connection: false,
            ModificationDate: null,
            ModificationUser: "",
            telecom_code: ""
        }

        this.emailAddressStore.addEntry(newEmail);
    }

    private _onClickReloadEmails(e): void {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_EmployeeProfile__LoadEmails", {}, lang.hitch(this, this._onReloadEmailsResponse), lang.hitch(this, this._onReloadEmailsError),);
    }

    private _onReloadEmailsResponse(response: Array<any>): void {
        this.emailAddressStore.setup(response);
        this.setAttributeValue("emailDiffData", null);
        this.StandbyStop();
    }

    private _onReloadEmailsError(error): void {
        this.StandbyStop();
        console.error(error);
    }


    loadEmployeeData(entityID?: string): void {
        if (!entityID) entityID = this.getCurrentUserId();
        this.entityId = entityID;

        let jsonData = {
            entityID: entityID
        };

        this.RequestManager.callfunction("Webtool_API_EmployeeProfile__LoadData",
            jsonData,
            lang.hitch(this, this._onLoadDataResponse),
            lang.hitch(this, this._onLoadDataError));
    }

    private _onLoadDataResponse(data: EmployeeProfileResponse): void {
        this.setData(data);
    }
    private _onLoadDataError(error: more.requestErrorMessage): void {
        alert(error.Message);
    }

    afterSetData(): void {
        let data: Person = this.currentData

        if (this.emailAddressStore) {
            let emails = this.getAttributeValue("emails");
            this.emailAddressStore.setup(emails);
            this.sectionEmailAddresses.setMarking(emails.length > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }

        this.setAttributeValue("emailDiffData", null);

        let email = this.getAttributeValue("web_user.email_address");
        console.log(email);
        this.inputUserMail.setReadonly(false);
        this.inputUserMail.setValue(email, true);

    }

    onDirtyChange(): void {
        this.emit("change", this.isDirty());
    }

    saveFormData(): void {
        this.StandbyStart();

        let data = {
            entityID: this.entityId,
            changedData: this.changedData
        };
        this.RequestManager.callfunction("Webtool_API_EmployeeProfile__SaveData",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError)
        );
    }


    private _onSaveDataResponse(response: more.requestResult): void {
        this.StandbyStop();
        console.log(response);
        this.emit("saved");
        this.showToast(this.translate("MainCatalogsEditor_SaveDlg_Message"), "fas fa-check")
    }

    private _onSaveDataError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        alert(error.Message);
    }




    private _profilePicUploadData: any = null;

    private _onClick_ProfilePic() {

        //if (!window.sessionInfo) {
        //    console.warn("cannot change profile pic - sessionInfo is not ready");
        //    return;
        //}

        let dlg = new GenericDialog();

        dlg._setHeaderAttr(this.translate("UserProfile__ChangeProfilePic"));
        dlg.closeOnEnter = false;
        dlg.destroyOnClose = false;

        dlg.set("callback", lang.hitch(this, this.profilePicDlgCallback, dlg));

        let container = this.UiModder.domConstruct.create("div", { "id": "profilePicDlg" });
        let imageContainer = this.UiModder.domConstruct.create("div", { "className": "profilePicContainer empty" }, container);
        let deleteBtnContainer = this.UiModder.domConstruct.create("div", { "className": "deleteButtonContainer w3-panel w3-block w3-center" }, container);

        let image = this.UiModder.domConstruct.create("img", {
            "src": "",
            "className": "profilePic"
        }, imageContainer);


        let deleteBtn = this.UiModder.domConstruct.create("button", {
            "className": "deleteButton mds-button-base round hoverBright tertiaryBG w3-hide",
            "innerHTML": this.translate("General_Remove")
        }, deleteBtnContainer);

        let deleteIcon = this.UiModder.domConstruct.create("i", { "className": "fas fa-times deleteIcon" }, deleteBtn, "first");

        let upload = new SimpleFileUpload();
        this.UiModder.domClass.add(upload.domNode, "w3-block w3-panel hidden");
        upload.placeAt(container);
        upload.on("change", lang.hitch(this, this._serializeProfilePicData, upload, deleteBtn, image, imageContainer, dlg));
        upload.startup();

        on(deleteBtn, "click", lang.hitch(this, this.removeProfilePic, deleteBtn, image, imageContainer, upload, dlg));
        on(imageContainer, "click", lang.hitch(upload, upload.click));

        if (window.sessionInfo) {
            let data = window.sessionInfo.getProfilepicData()
            //console.debug("_onClick_ProfilePic current profiledata", data);
            if (data) {
                if (data.base64) {
                    //setUserdefinedButton(text: string, iconClass: string, callback: Function, bCloseOnClick?: boolean, bSecondaryButton?: boolean)
                    //dlg.setUserdefinedButton("entfernen", "fas fa-trash-alt", lang.hitch(this, this.removeProfilePic), false, true);

                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domAttr.set(image, "src", "data:image/jpeg;base64," + data.base64);
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");

                    //let input =
                }
                else {
                    upload.click();
                }
            }
        }


        //dlg.show();
        dlg.show(null, this.translate("UserProfile__ChangeProfilePic"), null, null, "close");
        dlg.addNodeToContent(container);


    }

    private _serializeProfilePicData(fileUpload, deleteBtn, image, imageContainer, dlg) {
        let data = fileUpload.getUploadData();
        this._profilePicUploadData = data;
        //console.debug("_serializeProfilePicData", data);

        if (data) {
            if (data.files) {
                if (data.files[0].Base64Content) {
                    this.UiModder.domAttr.set(image, "src", data.files[0].Base64Content);
                    this.UiModder.domClass.add(image, "changed");
                    this.UiModder.domClass.remove(imageContainer, "empty");
                    this.UiModder.domClass.remove(deleteBtn, "w3-hide");
                }
            }
        }



        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private profilePicDlgCallback(dlg, result) {
        //console.debug("profilePicDlgCallback", result);

        if (result >= 1) {
            //domClass.add(dlg.domNode, "w3-disabled");
            this.uploadProfilePic(dlg);
        } else {
            dlg.destroy();
        }
    }

    private removeProfilePic(deleteBtn, image, imageContainer, upload, dlg, evt) {
        if (evt) {
            evt.stopPropagation();
        }

        upload.reset();

        //console.debug("removeProfilePic");
        this.UiModder.domClass.add(deleteBtn, "w3-hide");
        this.UiModder.domAttr.set(image, "src", "");
        this.UiModder.domClass.add(imageContainer, "empty");

        this._profilePicUploadData = null;

        dlg.set("closeBtn", false);
        dlg.set("cancelBtn", true);
        dlg.set("okBtn", true);
    }

    private uploadProfilePic(dlg: MdsLax<InstanceType<typeof GenericDialog>>) {

        let url = window.appRoot + "Home/UploadWebuserProfilePic";

        let data = { "webuserID": window.sessionInfo.getCurrentWebuserId(true), "data": this._profilePicUploadData };

        this.StandbyStart();

        this.RequestManager.post(url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onUploadProfilePicResponse, dlg),
            lang.hitch(this, this._onUploadProfilePicError, dlg)
        )
    }

    private _onUploadProfilePicResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response) {
        this.StandbyStop();

        dlg.destroy();

        this.StandbyStop();

        window.sessionInfo.checkForExistingSession();
    }


    private _onUploadProfilePicError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: more.requestErrorMessage) {
        alert("error uploading profile pic:\r\n" + error.Message);

        //domClass.remove(dlg.domNode, "w3-disabled");
        dlg.show();

        this.StandbyStop();
    }

    private _onLoadedMusicianProfile(hasInstruments: boolean) {
        this.sectionMusicianProfile.setMarking(hasInstruments ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChangeStore(data: { hasData: boolean, diffData }) {
        this.sectionMusicianProfile.setMarking(data.hasData ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.setAttributeValue("instrumentDiffData", data.diffData);
    }

    private _onChangeMail(value) {
        this.setAttributeValue("email_address", value);
    }

    postCreate(): void {
        this.RequestManager.handleAs = "jsonWithDate";
        super.postCreate.apply(this, arguments as any);

        if (this.hasUserRole("Login_MusicianProfile")) {
            this.musicianProfileform = new MusicianProfileForm();
            this.musicianProfileform.placeAt(this.sectionMusicianProfile);
            this.musicianProfileform.loadMusicianProfileData();
            this.musicianProfileform.on("loaded", lang.hitch(this, this._onLoadedMusicianProfile));
            this.musicianProfileform.on("changeStore", lang.hitch(this, this._onChangeStore));
            this.hideNode(this.containerMusicianProfile, false);

            this.setAttributeValue("instrumentDiffData", "");

            //this._setupTableEmail();

            this.inputUserMail.on("change", lang.hitch(this, this._onChangeMail))
        }
        // -----> ab hier sind die sections und data-keys registriert
        // initial readOnly

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        this.setStartupState("ready");
    }
}

export default mdsWidget(UserProfileForm);
